import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
} from '@mui/material'
import React, { ReactNode, useCallback } from 'react'
import './sf-dialog.scss'

interface SFDialogProps {
  title: string
  children: ReactNode
  isOpen: boolean
  onCancel: () => void
  onOk: () => void
  okButtonText?: string
  okButtonIcon?: string
  okButtonColor?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
  isOkDisabled?: boolean
  cancelButtonText?: string
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
}

const SFDialog: React.FC<SFDialogProps> = ({
  title,
  children,
  isOpen,
  onCancel,
  onOk,
  okButtonText = 'OK',
  okButtonIcon,
  okButtonColor = 'primary',
  isOkDisabled,
  cancelButtonText = 'Cancel',
  maxWidth = 'sm',
}) => {
  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCancel()
      }
    },
    [onCancel]
  )

  return (
    <Dialog
      open={isOpen}
      className="sf-dialog"
      onKeyDown={handleKeyDown}
      onClose={onCancel}
      fullWidth
      maxWidth={maxWidth}
    >
      <DialogTitle className="sf-dialog-header">
        {title}
        <IconButton aria-label="close" onClick={onCancel}>
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>
      <DialogContent className="sf-dialog-content">{children}</DialogContent>
      <div className="sf-dialog-footer">
        <Button onClick={onCancel} size="small" variant="outlined">
          {cancelButtonText}
        </Button>
        <Button
          onClick={onOk}
          variant="contained"
          size="small"
          color={okButtonColor}
          startIcon={okButtonIcon ? <Icon>{okButtonIcon}</Icon> : undefined}
          disabled={isOkDisabled}
        >
          {okButtonText}
        </Button>
      </div>
    </Dialog>
  )
}

export default SFDialog
